import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=0918f6b7"
import script from "./SaveButton.vue?vue&type=script&lang=ts"
export * from "./SaveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports